import User from '~/auth/User';

export const DEFAULT_PATH = '/';
export const LOGIN_ROUTE = 'login';

export function redirectToLoginRoute() {
  return navigateTo(`/${LOGIN_ROUTE}`);
}

export default defineNuxtPlugin(() => {
  addRouteMiddleware('guest', async (route: any) => {
    if (route.name === 'login-token-token') {
      const token = route.params.token as string;
      const groupHash = route.query.gh as string;
      return await new User().authenticate(token, groupHash);
    }

    if (!User.isAuthenticated() && route.name !== LOGIN_ROUTE) {
      return redirectToLoginRoute();
    }
  }, { global: true });

  addRouteMiddleware('auth', async () => {
    if (User.isAuthenticated()) {
      return navigateTo(DEFAULT_PATH);
    }
  });

  addRouteMiddleware('keep-alive', async () => {
    await (new User()).keepAlive();
  }, { global: true });
})
